import store from '@/store/store';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import * as devisConf from '@/configuration/devisConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import { get } from '@/api/produit/produitNumerique';
import { get as getProduitLocation } from '@/api/produit/produitLocation';
import calculDateFin from '@/services/general/calculDateFin';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import { get as getProduitAssocie } from '@/api/produit/index';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import updateQuantiteLiaisonTarif from '@/services/devisCommandes/updateQuantiteLiaisonTarif';
import * as saturationConvertisseur from '@/services/devisCommandes/numerique/saturationConvertisseur';
import calculTlpe from '@/services/dcf/tlpe/calculTlpe';
import setFournisseurIfNotRegie
  from '@/services/devisCommandes/bonAFacturer/setFournisseurIfNotRegie';
import setAFacturerOfLigne from '@/services/devisCommandes/bonAFacturer/setAFacturerOfLigne';
import genererCommentaireVenteForLigne from '@/services/devisCommandes/ajoutProduit/genererCommentaireVente';
import generationToutesLignesCommandes from './genererToutesLignesCommande';

async function generationLigneCommandeRegroupement(
  produitNumerique, produitsAssocies, periode, dcf, tauxTva,
) {
  const nouvelleLigneCommande = genererLigneCommande();
  miseAJourArticle(nouvelleLigneCommande);
  nouvelleLigneCommande.title = [
    produitNumerique?.reference,
    produitsAssocies.libelle,
  ].filter(Boolean).join(' - ');
  nouvelleLigneCommande.produitId = produitNumerique.id;
  nouvelleLigneCommande.typeProduit = produitConf.CATEGORIE_ECRAN_NUMERIQUE;
  nouvelleLigneCommande.produit = produitNumerique;
  nouvelleLigneCommande.tauxTva = 0;
  const dateJour = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
  if (periode) {
    nouvelleLigneCommande.dateDebut = periode.dateDebut ? periode.dateDebut.toDate()
      : dcf && dcf.datePremiereAffichage || dateJour;
    nouvelleLigneCommande.dateFin = periode.dateFin ? periode.dateFin.toDate() : calculDateFin(
      nouvelleLigneCommande.dateDebut, 1, devisConf.ANNEE,
    );
  } else {
    nouvelleLigneCommande.dateDebut = dcf && dcf.datePremiereAffichage || dateJour;
    const dateFin = calculDateFin(
      nouvelleLigneCommande.dateDebut, produitsAssocies.quantite, produitsAssocies.uniteVente,
    );
    if (dateFin) nouvelleLigneCommande.dateFin = dateFin;
    else {
      nouvelleLigneCommande.dateFin = calculDateFin(
        nouvelleLigneCommande.dateDebut, 1, devisConf.ANNEE,
      );
    }
  }
  nouvelleLigneCommande.libelle = produitNumerique.libelle;
  nouvelleLigneCommande.masqueLigne = false;
  nouvelleLigneCommande.type = devisConf.REGROUPEMENT;
  if (produitsAssocies && produitsAssocies.produitEnfant) {
    nouvelleLigneCommande.lignesCommande = await generationToutesLignesCommandes(
      produitsAssocies, tauxTva,
    );
  } else nouvelleLigneCommande.lignesCommande = [];

  // AJOUT D INFORMATION SUPPLEMENTAIRE EN FONCTION DE LA SOCIETE (REGIE, MANDATIARE ...)
  setFournisseurIfNotRegie(produitNumerique, nouvelleLigneCommande);
  setAFacturerOfLigne(nouvelleLigneCommande, dcf);

  return nouvelleLigneCommande;
}

export async function ajoutLignesCommandeProduitEcranNumeriqueViaObject(
  devisCommande, produitEcran, produitAssocie, ordre, periode, typeProduitNumerique, tauxTva,
) {
  let liaisonTarif = [];
  if (produitAssocie !== null) {
    if (periode && periode.dateDebut) {
      liaisonTarif = returnLiaisonTarif(
        produitEcran, produitAssocie.id, new Date(periode.dateDebut),
      );
      // Voir tarifDansLePanier
      // La quantité de la liaison tarif est remplacée
      // dans certains cas
      updateQuantiteLiaisonTarif(liaisonTarif, periode.dateDebut, periode.dateFin);
      if (liaisonTarif && liaisonTarif.quantiteAjustee) {
        liaisonTarif.quantite = liaisonTarif.quantiteAjustee;
      }
    } else liaisonTarif = returnLiaisonTarif(produitEcran, produitAssocie.id, new Date());
    if (!liaisonTarif) {
      liaisonTarif = genererLiaisonTarifFromProduitAssocie(
        produitAssocie, periode,
      );
    }
  }
  const nouvelleLignesCommande = await generationLigneCommandeRegroupement(
    produitEcran, liaisonTarif, periode, devisCommande, tauxTva,
  );
  if (typeProduitNumerique) {
    nouvelleLignesCommande.typeProduit = typeProduitNumerique;
  }
  if (periode && periode.saturation) {
    nouvelleLignesCommande.quantiteDispo = saturationConvertisseur
      .toQuantiteDispo(periode.saturation);
  }
  ajoutOrdre(nouvelleLignesCommande, devisCommande.lignesCommande.length, ordre);
  genererCommentaireVenteForLigne(produitEcran, nouvelleLignesCommande);
  try {
    await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key]);
    const parametresInterne = store.getters['parametres/parametresInterne'];
    const surPeriode = parametresInterne(PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key);
    await calculTlpe(
      nouvelleLignesCommande,
      devisCommande.type === devisConf.TYPE_FACTURE,
      surPeriode,
      devisCommande.repartitionPayeurSurFacture,
    );
  } catch (e) {
    nouvelleLignesCommande.lignesCommande.forEach((el) => {
      if (el.typeProduit === produitConf.CATEGORIE_DIVERS && el.calculAutomatiqueTlpe
        && el.produit.produitDivers.tlpe) {
        el.prixUnitaire = 0;
      }
    });
  }
  return [nouvelleLignesCommande];
}

export async function ajoutLignesCommandeProduitEcranNumeriqueViaId(
  devisCommande, idProduit, idProduitAssocie, ordre, tauxTva, type,
) {
  let saturation = null;
  const produitEcran = (await get(idProduit)).data.result;

  let produitAssocie = null;
  if (idProduitAssocie) {
    produitAssocie = (await getProduitAssocie(idProduitAssocie))
      .data.result;
    if (produitAssocie.supportCommercial.categorieVente === produitConf.CATEGORIE_LOCATION) {
      const produitLoc = (await getProduitLocation(produitAssocie.id)).data.result;
      saturation = produitLoc.produitLocation.saturation;
    }
  }
  return ajoutLignesCommandeProduitEcranNumeriqueViaObject(
    devisCommande, produitEcran, produitAssocie, ordre,
    { saturation: saturation }, type, tauxTva,
  );
}
